import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import CustomLoader from "../../components/CustomLoader";

const localCustomStyles = {
  headCells: {
    style: {
      // color: "#0E9ADA",
      // fontSize: "12.5px",
      // fontWeight: "bold",
    },
  },
  rows: {
    style: {
      padding: "10px 0px",
      //   borderLeft: "6px solid #203a75",
    },
  },

  expanderButton: {
    style: {
      svg: {
        display: "none",
      },
    },
  },
};
const TableNoBorder = ({
  columns,
  data,
  loading,
  status,
  noTableHead = false,
  customStyles = localCustomStyles,
  conditionalRowStyles,
  expandableRows = false,
  expandableRowsComponent,
  expandableRowExpanded,
  dense,
  pagination = true,
  highlightOnHover = true,
}) => {
  return (
    <Fragment>
      <div className="animate-fade-in-down1 box-shadow">
        <div className="bg-white">
          <DataTable
            customStyles={customStyles}
            responsive={true}
            columns={columns}
            data={data}
            progressPending={status === "loading" || loading}
            progressComponent={<CustomLoader />}
            pagination={pagination}
            paginationComponentOptions={{ noRowsPerPage: true }}
            paginationPerPage={5}
            noTableHead={noTableHead}
            persistTableHead={true}
            highlightOnHover={highlightOnHover}
            expandableRows={expandableRows}
            expandableRowsComponent={expandableRowsComponent}
            expandableRowExpanded={expandableRowExpanded}
            conditionalRowStyles={conditionalRowStyles}
            dense={true}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default TableNoBorder;
